//allapi url's
const base_url="http://localhost:1000/"

export const end_points={
    user:"user",
    admin:"admin",
    products:"product",
    cart:"cart"
}
export default base_url